import { render, staticRenderFns } from "./ApplyReasonRemarkView.vue?vue&type=template&id=2fc92129&scoped=true"
import script from "./ApplyReasonRemarkView.vue?vue&type=script&lang=js"
export * from "./ApplyReasonRemarkView.vue?vue&type=script&lang=js"
import style0 from "./ApplyReasonRemarkView.vue?vue&type=style&index=0&id=2fc92129&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc92129",
  null
  
)

export default component.exports